module.exports = __webpack_public_path__ + "static/media/gallaxy-background-art.4964fc23.webp";